<template>
<div class="col-info">
    <a-badge :class="badgeCssClass" :count="appointmentType" />
    <p style="font-size: 14px;font-weight: 600;color: #141414;margin-bottom: 14px;">
        {{ $t('appointment-fields.applied-on') }}: {{ applicationDate }} 
    </p>
    <a-avatar
        slot="avatar"
        :size="48"
        shape="square"
        :src="visitorImageUrl"
    />
    <a-descriptions :title="visitorName" :column="1">
        <a-descriptions-item :label="$t('appointment-fields.district')">
            {{ visitorAddress }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('appointment-fields.contact')">
            {{ visitorContact }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('appointment-fields.agenda')">
            {{ appointmentTopic }}
        </a-descriptions-item>
    </a-descriptions>

    <div style="display: flex; flex-direction: column; margin-top: 14px;">
        <div style="font-size: 13px;font-weight: 600;color: #8C8C8C; margin-bottom: 5px;">
            {{ $t('appointment-fields.appointment-for')}}
        </div>
        <div style="display: flex; ">
            <a-avatar
                slot="avatar"
                size="small"
                shape="square"
                :src="officialImageUrl"
                style="margin-right: 10px;"
            />
            <span style="font-size: 13px;font-weight: 600;color: #141414;">
                {{ officialName }}
            </span>
        </div>
    </div>
</div>    
</template>

<script>

import { DateHelpers } from '../../../helpers/DateHelpers';
import { mapActions, mapState } from "pinia";
import { useLocaleStore } from "../../../stores/locale-store.js"; 
export default {
    props: {
        appointment: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapState(useLocaleStore, ['locale']),
        visitorImageUrl() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.imageUrl && this.appointment.visitor.imageUrl.length > 0)
                return this.appointment.visitor.imageUrl;
            return '/images/default-avatar.jpg';
        },
        applicationDate() {
            if (this.appointment && this.appointment.dateCreated) {
                return this.$d(new Date(this.appointment.dateCreated), 'short');
                // return DateHelpers.formatToReadableDate(this.appointment.dateCreated);
            }
            return '';
        },
        visitorName() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.fullName)
                return this.appointment.visitor.fullName;
            return '';
        },
        visitorAddress() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.address)
                return this.appointment.visitor.address;
            return '';
        },
        visitorCompany() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.company)
                return this.appointment.visitor.company;
            return '';
        },
        visitorContact() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.mobile)
                return this.appointment.visitor.mobile;
            return '';
        },
        officialImageUrl() {
            
            if (this.appointment && this.appointment.official && this.appointment.official.imageUrl && this.appointment.official.imageUrl.length > 0)
                return this.appointment.official.imageUrl;
            return '/images/default-avatar.jpg';
        },
        officialName() {
            if (this.appointment && this.appointment.official && this.appointment.official.name) {
                if (this.locale == 'en')
                    return this.appointment.official.name;
                else
                    return this.appointment.official.nameBn;
            }
            return '';
        },
        badgeCssClass() {
            if (this.appointment) {
                if (this.appointment.type == 'IN_PERSON')
                    return 'in-person'
                else if (this.appointment.type == 'ONLINE')
                    return 'online';
            }
            return '';
        },   
        appointmentTopic() {
            if (this.appointment && this.appointment.topic) {
                if (this.appointment.topic.toLowerCase().includes('personal'))
                    return this.$t('appointment-fields.topic-personal');
                else if (this.appointment.topic.toLowerCase().includes('official'))
                    return this.$t('appointment-fields.topic-official');
            }
            return '';
        },
        appointmentType() {
            if (this.appointment && this.appointment.type) {
                if (this.appointment.type == 'IN_PERSON')
                    return this.$t('appointment-types.in-person');
                else if (this.appointment.type == 'ONLINE')
                    return this.$t('appointment-types.online');
            }
            return '';
        }       

    }
}
</script>